import Spinner from 'react-bootstrap/Spinner';
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import DataTable from  '../DataTable/DataTable';
import { useEffect, useState,useRef } from 'react';
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import { Block, BlockHead, BlockHeadBetween, BlockHeadContent} from '../../components';
import { Alert } from 'react-bootstrap';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareSettings/regionlist/";

const pagetitle = "Regions";
const pagetitleAddNew = "Add Region";
const pagetitleUpdate = "Update Region";

export const tableColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: false,
      hide : "lg",
      omit : true,

    },
    {
        name: "name",
        selector: (row) => row.regionName,
        sortable: true,                        
    },
    {
        name: "Date Modified",
        selector: (row) => new Date(row.dateModified).toLocaleString(),
        sortable: true,                
    },
    {
        name: "Date Created",
        selector: (row) => new Date(row.dateCreated).toLocaleString(),
        sortable: true,                
    },
    {
        name: "",
        Button:true,              
        cell: (row) => (                 
            <>
            <Icon name="edit-fill"></Icon>Edit
            </>           
        ),
        sortable: false,      
    },
]



const RegionSettings = () => {

    const api = useApiClient();
    const dataFetchedRef = useRef(false);

    const [DatatoUse, setData] = useState(null);
    const [error, setError] = useState(null);
  
    const modalForm = useRef(null);
    const modalFormAdd = useRef(null);
    const [selectedData, setSelectedData] = useState([]);
    const [previewModal, setPreviewModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);
    
    

    useEffect(()=> {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        api.get(baseURL)        
        .then((Response)=>{
            setData(Response.data);
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

    },[])

    if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!DatatoUse) return(
            <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
        );

function detailSelect(obj){

    console.log(obj);

    const currentData = {...selectedData,
    id:obj.id,
    regionName:obj.regionName,
    dateCreated: obj.dateCreated,
    dateModified: obj.dateModified
    }

    setSelectedData(currentData)
    setPreviewModal(true)

    }



function closePreviewModal(){
    setPreviewModal(false);
    } 

function closeAddModal(){
    setAddModal(false);
    } 

function openAddModel(){
    setAddModal(true);
    } 
    

function openDeleteModal(){

    const frmFormData = new FormData();
    const sURL = "HMCareSettings/deleteregion/"+selectedData.id;

    api.post(sURL,frmFormData)
    .then((Response)=>{

        if(Response.data==true){      
        const updatedDataList = DatatoUse.filter((item) => item.id !== selectedData.id)
        setData(updatedDataList);
        }                          
    }).catch(error => {
        setError(error);     
        console.log({error})
    });

    setPreviewModal(false);

    }   

function openEditModal(){
    //setPreviewModal(false);
    }   


const updateState = (updatedData) => {

    const newState = DatatoUse.map(obj => {
        // 👇️ if id equals 2, update country property
        if (obj.id === updatedData.id) {
        return {...obj, regionName: updatedData.regionName};
        }

        // 👇️ otherwise return the object as is
        return obj;
    });
    
    setData(newState);
    
    };


    function handleFormSubmit(event){

        event.preventDefault();
        let newName = modalForm.current.querySelector('#dataname').value;
        console.log(newName);
        
        const frmFormData = new FormData();
        frmFormData.append("id", selectedData.id) 
        frmFormData.append("regionName", newName) 
        
        const sURL = "HMCareSettings/updateregion/";

        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;            
            updateState(updatedDataObj)
            
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setPreviewModal(false);

    }   


    function handleAddFormSubmit(event){

        event.preventDefault();
        let newName = modalForm.current.querySelector('#dataname').value;
        console.log(newName);
        
        const frmFormData = new FormData();        
        frmFormData.append("regionName", newName) 
        
        const sURL = "HMCareSettings/addregion/";

        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;            

            const UpdateList = [{
                id : updatedDataObj.id,
                regionName : updatedDataObj.regionName,
                dateCreated : updatedDataObj.dateCreated,
                dateModified : updatedDataObj.dateModified,
            },...DatatoUse]    

            //console.log(UpdateList)

            setData(UpdateList)    

            
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setAddModal(false);

    }   



  return (

    <>
    <Layout title="HMCarePlanner - Settings" content="container">
    <Block.Head page className="wide-md">
        <Block.HeadContent>
            <Block.Title>{pagetitle}</Block.Title>
            <Block.Text>Manage {pagetitle} settings</Block.Text>           
        </Block.HeadContent>
    </Block.Head>    
    <BlockHead page>   
                <BlockHeadBetween>
                    <BlockHeadContent>
                    {error && 
                    <Alert variant="danger">
                        {error}
                    </Alert>
                    }    
    
      </BlockHeadContent>

      <BlockHeadContent tools>      
      <Button variant="outline-primary" action="add" onClick={openAddModel}>
        <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
    </Button>
</BlockHeadContent>
                </BlockHeadBetween>
            </BlockHead>
        <DataTable 
            tableClassName="data-table-head-light table-responsive" 
            pointerOnHover={true} 
            data={DatatoUse}                     
            columns={tableColumns} 
            striped={true} 
            highlightOnHover={true}  
            filterFieldName="regionName" 
            onRowClicked={(row,event)=>{ detailSelect(row) }}            
            //actions="export"             
        />
        
    </Layout>

<Modal show={previewModal} onHide={closePreviewModal}>
<Modal.Header closeButton>
  <Modal.Title className="event-title" as="h4">Modify {pagetitle} - {selectedData.name}(#{selectedData.id})</Modal.Title>  
</Modal.Header>

<Form ref={modalForm} onSubmit={handleFormSubmit}>
<Modal.Body>
  <div>
    <Row className="g-3">       
        <Col xs="12">
            <Form.Group>
                <Form.Label htmlFor="eventTitle">Name</Form.Label>
                <div className="form-control-wrap">
                    <Form.Control id="dataname" type="text" defaultValue={selectedData.regionName} placeholder="Value" />
                </div>
            </Form.Group>
        </Col>
        <Col xs="12">
            <h6 className="overline-title">Date Created</h6>
            <p className="event-end small">{selectedData.dateCreated} </p>
        </Col>
        <Col xs="12">
            <h6 className="overline-title">Date Modified</h6>
            <p className="event-end small">{selectedData.dateModified} </p>
        </Col>        
    </Row>
  </div>
</Modal.Body>
<Modal.Footer>
    <Button variant="danger" onClick={openDeleteModal}>Delete</Button>    
    <Button variant="primary" type="submit">Update Data</Button>
</Modal.Footer>
</Form>
</Modal>

<Modal show={AddModal} onHide={closeAddModal}>
<Modal.Header closeButton>
  <Modal.Title className="event-title" as="h4">Add a new Region</Modal.Title>  
</Modal.Header>

<Form ref={modalForm} onSubmit={handleAddFormSubmit}>
<Modal.Body>
  <div>
    <Row className="g-3">       
        <Col xs="12">
            <Form.Group>
                <Form.Label htmlFor="eventTitle">Name</Form.Label>
                <div className="form-control-wrap">
                    <Form.Control id="dataname" type="text" defaultValue={''} placeholder="Value" />
                </div>
            </Form.Group>
        </Col>        
    </Row>
  </div>
</Modal.Body>
<Modal.Footer>
    <Button variant="primary" type="submit">Add Region</Button>
</Modal.Footer>
</Form>
</Modal>

</>
  )
}

export default RegionSettings